import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import './RootLayout.css'

/**
 * ルートレイアウトコンポーネント
 *
 * アプリケーション全体の構造を定義:
 * - デスクトップ: 固定ヘッダー + 左サイドバー + メインコンテンツ
 * - モバイル: 固定ヘッダー + スライドインメニュー + メインコンテンツ
 */
export function RootLayout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen)
  const closeMobileMenu = () => setIsMobileMenuOpen(false)

  return (
    <div className="root-layout">
      <Header onMenuToggle={toggleMobileMenu} />
      <Sidebar isOpen={isMobileMenuOpen} onClose={closeMobileMenu} />

      <main className="main-content">
        <div className="main-content-inner">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
